import * as oauthApi from 'spa/api/oauth'
import { error } from 'react-notification-system-redux'

export const REQUEST_OAUTH_LOGIN = 'REQUEST_OAUTH_LOGIN'
export const RECEIVE_OAUTH_LOGIN = 'RECEIVE_OAUTH_LOGIN'
export const OAUTH_LOGIN_ERROR = 'OAUTH_LOGIN_ERROR'

export const requestOAuthLogin = () => ({
  type: REQUEST_OAUTH_LOGIN,
})

export const receiveOAuthLogin = () => ({
  type: RECEIVE_OAUTH_LOGIN,
})

export const oauthLoginError = error => ({
  type: OAUTH_LOGIN_ERROR,
  error,
})

export function loginWithBeatport() {
  return async function(dispatch) {
    try {
      dispatch(requestOAuthLogin())

      const response = await oauthApi.initiateBeatportAuth()
      const data = response.data || response

      if (data.success && data.authURL) {
        window.location.href = data.authURL
      } else {
        throw new Error('Failed to initiate OAuth flow')
      }
    } catch (err) {
      dispatch(receiveOAuthLogin())
      dispatch(oauthLoginError(err.message))
      dispatch(
        error({
          title: 'Login Error',
          message: 'Failed to initiate login with Beatport. Please try again.',
          position: 'tr',
          autoDismiss: 5,
        })
      )
    }
  }
}
